<template>
    <v-sheet class="i-field">
        
        <label v-if="label != null && label != ''" :for="id">{{ $t(label) }}</label>
        <v-text-field
            :ref="'textField' + id"
            :modelValue="modelValue"
            :id="id"
            :name="id"
            :label="innerlabel"
            :aria-describedby="id"
            :variant="variant == '' ? variant : 'outlined'"
            :density="density == '' ? density : 'compact'"
            :type="type"
            :rules="rules"                  
            :error-messages="errorMessages"      
            validate-on="submit"
            :append-inner-icon="appendInnerIcon"
            @click:append-inner="clickIcon"
            @click:clear="clickClear"
            :clearable="clearable"
            :placeholder="placeholder != null ? $t(placeholder) : undefined"
            :persistent-placeholder="persistentPlaceholder"
            @update:model-value="(val) => onUpdated(val)"
            @input="onInput"
            :readonly="readonly"
            :disabled="disabled"
            autocomplete="off"
            >
        </v-text-field>
    </v-sheet>
</template>

<script>
export default {
    props: ["label", "modelValue", "id", "placeholder", "type", "rules", "variant", "density", "persistentPlaceholder", "screenReader", "fixedLabel", "readonly", "disabled", "appendInnerIcon", "errorMessages", "clearable", "innerlabel"],
    methods: {
        onUpdated: function(value) {
            this.$refs['textField' + this.id].resetValidation()
            this.$emit("update:modelValue", value)
        },
        clickIcon() {
            this.$emit('click:append-inner')
        },
        clickClear() {
            this.$emit('click:clear')
        },
        validate() {
           return this.$refs['textField' + this.id].validate()
        },
        onInput(val) {
            this.$emit('onInput', val)
        }
    }
}
</script>

<style>
</style>